import { HeaderRegion } from '../../data/types';
import { REGION_COOKIE_NAME } from '../../data/resolveRegion';

// PST-570 — 헤더 region 연속성 쿠키.
// 우선순위(주입 ?? URL isDomestic ?? 쿠키 ?? overseas) 중 3번째 소스.
// 권위 신호(주입/URL)로 region 이 확정될 때 기록하여, region 신호가 없는 화면(마이페이지·주문 등)이
// 마지막 region 을 승계하도록 한다.
// 쿠키 이름은 data/resolveRegion 의 REGION_COOKIE_NAME 을 단일 소스로 공유한다.

const COOKIE_NAME = REGION_COOKIE_NAME;
// 7일. Safari ITP(client 쿠키 7일 상한)와 일치 → client-side set 이어도 브라우저 간 동일 동작.
const MAX_AGE_SEC = 7 * 24 * 60 * 60;

// 앱마다 서브도메인(accommodation./main./order.…)이 달라, 부모 도메인에 심어야 앱 간 공유·읽기 가능.
// 로컬/비-myrealtrip 호스트는 도메인 미지정(host-only)으로 두어 로컬에서도 동작하게 한다.
//
// ⚠️ 환경별 등록가능 도메인이 다르다: prod=myrealtrip.com / stage=stage-myrealtrip.com /
// dev=dev-myrealtrip.com … `www.stage-myrealtrip.com` 에서 domain=.myrealtrip.com 을 심으면
// 도메인 매칭 실패로 브라우저가 쿠키를 거부한다(= stage/dev 에서 쿠키가 안 구워짐).
// 현재 호스트의 등록가능 도메인(마지막 두 라벨: {prefix}myrealtrip.com)으로 심어 앱 간 공유를 보장한다.
function domainAttr(): string {
  if (typeof window === 'undefined') return '';
  const host = window.location.hostname;
  if (!host.includes('myrealtrip.com')) return '';
  const registrableDomain = host.split('.').slice(-2).join('.');
  return `; domain=.${registrableDomain}`;
}

// 쿠키 이름은 COOKIE_NAME 단일 소스에서 정규식을 조립한다(하드코딩 금지 — read/write 불일치 방지).
const REGION_COOKIE_RE = new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=(domestic|overseas)`);

export function readRegionCookie(): HeaderRegion | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(REGION_COOKIE_RE);
  return match ? (match[1] as HeaderRegion) : null;
}

export function writeRegionCookie(region: HeaderRegion): void {
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=${region}; path=/; max-age=${MAX_AGE_SEC}; SameSite=Lax${domainAttr()}${secure}`;
}
